module.exports = __webpack_public_path__ + "img/bg_tjhq@2x.272be853.png";